import { render, staticRenderFns } from "./WarrantyPage.vue?vue&type=template&id=c7ceba74&"
import script from "./WarrantyPage.vue?vue&type=script&lang=js&"
export * from "./WarrantyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports